import { render, staticRenderFns } from "./small-label.vue?vue&type=template&id=3fdd7db4&scoped=true"
import script from "./small-label.vue?vue&type=script&lang=js"
export * from "./small-label.vue?vue&type=script&lang=js"
import style0 from "./small-label.vue?vue&type=style&index=0&id=3fdd7db4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd7db4",
  null
  
)

export default component.exports